module.exports = __webpack_public_path__ + "img/pro_thirteen_2.858718d2.jpg";